import React, { useState } from 'react';
import { Grid, IconButton, InputAdornment, TextField, Tooltip } from '@material-ui/core';
import { Field } from 'formik';
import { EyeIcon, EyeSlashIcon } from '../../icons';

const FormikPasswordInput = ({ name, ...props }) => {
    const [showPassword, setShowPassword] = useState(false);
    const handleToggleShowPassword = () => setShowPassword(!showPassword);

    return (
        <Grid item xs={12}>
            <Field name={name}>
                {({ field, meta }) => (
                    <TextField
                        {...field}
                        {...props}
                        error={meta.error && meta.touched}
                        helperText={meta.touched && meta.error}
                        fullWidth
                        type={showPassword ? 'text' : 'password'}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip title={`${showPassword ? 'Hide' : 'Show'} password`}>
                                        <IconButton onClick={handleToggleShowPassword} edge="end">
                                            {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            )
                        }}
                    />
                )}
            </Field>
        </Grid>
    );
};

export default FormikPasswordInput;
